module.exports = __webpack_public_path__ + "img/M022.9a7d9801.jpg";